// src/pages/Home.js
//
import Dashboard from './parts/Dashboard';

const Home = () => {
  return (
    <div className="home">
      <Dashboard />
    </div>
  );
};

export default Home;
